<div class="p-6">
    <h2 mat-dialog-title>Confirm Deletion</h2>
    <mat-dialog-content>
        Are you sure you want to remove this?
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close color="primary">Cancel</button>
        <button mat-button [mat-dialog-close]="true" color="warn">Delete</button>
    </mat-dialog-actions>
</div>